function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
export default class ContextContent extends Component {
  render() {
    const {
      color,
      children,
      className,
      hasFullSeparator,
      height,
      maxHeight,
      padding,
      paddingHorizontal = padding,
      paddingVertical = padding,
      ...rest
    } = this.props;
    const classes = classnames(className, "ax-context-content", `ax-context-content--padding-horizontal-${paddingHorizontal}`, `ax-context-content--padding-vertical-${paddingVertical}`, {
      [`ax-context-content--${color}`]: color,
      "ax-context-content--full-separator": hasFullSeparator,
      "ax-context-content--scrollable": height || maxHeight
    });
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      className: classes
    }), /*#__PURE__*/React.createElement("div", {
      className: "ax-context-content__scroll",
      style: {
        height,
        maxHeight
      }
    }, children));
  }
}
_defineProperty(ContextContent, "defaultProps", {
  hasFullSeparator: false,
  padding: "large"
});